import { storageItems } from '@va/standalone/shared/constants';
import moment from 'moment';
import { LocalStorage } from '../storage';

export function getRefreshTokenExpiry() {
  return LocalStorage.getItem(storageItems.refreshTokenExpiry);
}

export function isRefreshTokenExpired() {
  return moment().unix() > Number(getRefreshTokenExpiry());
}

export const isKnownSubdomain = (domain: string): boolean => {
  const knownDomains = ['va-endpoint.com', 'stage.va-endpoint.com', 'visitor-analytics.io'];

  for (const v of knownDomains) {
    if (domain.includes(v)) {
      return true;
    }
  }

  return false;
};
